import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 38807077-1E35-4599-83CA-110DA473794A
 * name human-male-height
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-height.svg
 * tags
 * - Medical / Hospital 
 * - People / Family 
 */
export const HumanMaleHeightIcon = createSvgIcon(<><path d="M7,2C8.78,2 9.67,4.16 8.42,5.42C7.16,6.67 5,5.78 5,4A2,2 0 0,1 7,2M5.5,7H8.5A2,2 0 0,1 10.5,9V14.5H9V22H5V14.5H3.5V9A2,2 0 0,1 5.5,7M21,8H15V10H21M21,11H18V13H21M21,2H15V4H21M21,5H18V7H21M21,14H15V16H21M21,20H15V22H21M21,17H18V19H21" /></>, 'HumanMaleHeightIcon');
export default HumanMaleHeightIcon